import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Checkbox from '../base/Checkbox';

import styles from './Select.scss';

export default class MultiselectItem extends React.PureComponent {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    showStatus: PropTypes.bool,
    status: PropTypes.string,
    maxLimitTooltip: PropTypes.string,
    tooltipTitle: PropTypes.string,
  };

  static defaultProps = {
    id: null,
  };

  handleToggle = () => {
    const { id, selected, onToggle } = this.props;
    onToggle(id, !selected);
  };

  render() {
    const {
      title,
      selected,
      showStatus,
      status,
      maxLimitTooltip,
      tooltipTitle,
    } = this.props;

    const listItemClassName = selected ? 'active' : null;
    const checkboxClassName = classnames('text-ellipsis', {
      [styles.selectedItem]: selected,
    });

    return (
      <li className={listItemClassName}>
        <Checkbox
          showToolTip
          className={checkboxClassName}
          label={title}
          maxLimitTooltip={maxLimitTooltip}
          showStatus={showStatus}
          status={status}
          tooltipTitle={tooltipTitle}
          value={selected}
          onChange={this.handleToggle}
        />
      </li>
    );
  }
}
